import { TooltipProvider } from "@radix-ui/react-tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { NuqsAdapter } from "nuqs/adapters/react-router/v7";
import { FC, PropsWithChildren } from "react";
import { CookiesProvider } from "react-cookie";
import UserSwitchProvider from "./user-switch-provider";
import WizardRedirectProvider from "./wizard-redirect-provider";
import { ThemeMeta } from "./theme-meta";

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false } },
});

const Providers: FC<PropsWithChildren> = ({ children }) => {
  return (
    <CookiesProvider>
      <TooltipProvider delayDuration={0}>
        <WizardRedirectProvider>
          <NuqsAdapter>
            <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
              <ThemeMeta />
              <QueryClientProvider client={queryClient}>
                <UserSwitchProvider>{children}</UserSwitchProvider>
              </QueryClientProvider>
            </ThemeProvider>
          </NuqsAdapter>
        </WizardRedirectProvider>
      </TooltipProvider>
    </CookiesProvider>
  );
};

export default Providers;
